import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";

const PUBLIC = process.env.PUBLIC_URL || "";
const SA_IMAGE = `${PUBLIC}/brand/san-antonio-skyline.jpg`;

const BENEFITS = [
  "Reduce Costs",
  "Increase Agility",
  "Strengthen Security",
  "Drive Innovation",
  "Achieve Real Business Outcomes",
];

export default function CloudJourney() {
  return (
    <section className="relative isolate overflow-hidden" data-testid="cloud-journey">
      {/* Full-section background image (blended / faded) */}
      <div className="absolute inset-0 -z-10" aria-hidden="true">
        <img
          src={SA_IMAGE}
          alt=""
          loading="lazy"
          className="h-full w-full object-cover object-center"
        />
        {/* overall soft fade so it reads as a blended background */}
        <div className="absolute inset-0 bg-white/15" />
        {/* left-to-right light gradient for text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-white/85 via-white/50 to-white/10" />
        {/* subtle warm San Antonio tint + top/bottom blend into page */}
        <div className="absolute inset-0 bg-gradient-to-tr from-primary/10 via-transparent to-cbgreen/10" />
        <div className="absolute inset-x-0 top-0 h-16 bg-gradient-to-b from-white to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-white to-transparent" />
      </div>

      <div className="container-cb py-20 lg:py-28">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-12">
          {/* Text block */}
          <div className="lg:col-span-7">
            <p className="eyebrow">Cloud Beaker</p>
            <h2 className="mt-3 font-display text-3xl font-extrabold leading-[1.08] tracking-tight text-cbink sm:text-[40px] lg:text-[46px]">
              Your Cloud Journey.<br />
              <span className="text-primary">Our Expertise.</span>
            </h2>
            <p className="mt-5 max-w-lg text-[16px] leading-relaxed text-cbslate sm:text-[17px]">
              No matter where you are in your cloud journey &mdash; from San Antonio to anywhere in the world &mdash; we&rsquo;ll help you reach what&rsquo;s next across Google Cloud, Microsoft and Alibaba Cloud.
            </p>
            <Link to="/book" className="btn-primary mt-7" data-testid="journey-cta">
              Start Your Journey <ArrowRight size={16} />
            </Link>
          </div>

          {/* Benefits checklist */}
          <div className="lg:col-span-5 lg:pl-6">
            <ul className="space-y-4">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-center gap-3">
                  <CheckCircle2 size={22} className="shrink-0 text-cbgreen" />
                  <span className="text-[15px] font-semibold text-cbink sm:text-base">{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
